import { useState, useEffect } from 'react';
import LogoTitle from '../../assets/images/logo-s.png'
import Loader from 'react-loaders';
import { Link } from 'react-router-dom'
import '../Layout/index.scss';
import '../Home/index.scss';
import AnimatedLetters from '../AnimatedLetters';
import Logo from './logo';
import Ultima from '../../assets/images/Mac-Ultima.png'
import TriviaBall from '../../assets/images/Mac-TriviaBall.png'
import NetHive from '../../assets/images/Mac-NetHive.png'
import { AiOutlineDown } from 'react-icons/ai';

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = ['e', 't', 'h']
    const jobArray = ['a',' ','w','e','b',' ','d','e','v','e','l','o','p','e','r','.',]
    let [runanimate, setRunAnimate] = useState(false)
    const [isVisible, setIsVisible] = useState(false);
    const [willVisible, setWillVisible] = useState(false);

    
    
    let itemsHTMLCollection = document.getElementsByClassName('parallax-item');
    let imagesHTMLCollection = document.getElementsByClassName('images');
    let divsHTMLCollection = document.getElementsByClassName('my-text')
    let itemsArray = Array.from(itemsHTMLCollection);
    let imagesArray = Array.from(imagesHTMLCollection);
    let divsArray = Array.from(divsHTMLCollection);
    let container = document.getElementById('container')

    var input = {
        scrollY:{
            start: 0,
            end: container?.scrollHeight - container?.clientHeight,
            current: 0,
        },
        mouseX: {
            start: 0,
            end: window.innerWidth,
            current: 0,
        },
        mouseY:{
            start: 0,
            end: window.innerHeight,
            current: 0,
        }
    }

    input.scrollY.range = input.scrollY.end - input.scrollY.start;
    input.mouseX.range = input.mouseX.end - input.mouseX.start;
    input.mouseY.range = input.mouseY.end - input.mouseY.start;

    var output = {
        x: {
            start: -150,
            end: 150,
            current: 0,
        },
        y:{
            start: 0,
            end: 30000,
            current: 0,
        },
        z:{
            range: 10000
        },
        scale:{
            start: 1,
            end: 0.3
        },
        blur:{
            startingDepth: .1,
            range: 10
        }
    }

    output.scale.range = output.scale.end - output.scale.start
    output.x.range = output.x.end - output.x.start
    output.y.range = output.y.end - output.y.start

    var mouse = {
        x: window.innerWidth * .5,
        y: window.innerHeight * .5
    }

    function updateArrow(){
        if (input.scrollY.fraction > 0.88){
            setIsVisible(false)
        }
    }

    function updateInputs(){
        // mouse x input
        input.mouseX.current = mouse.x;
        input.mouseX.fraction = (input.mouseX.current - input.mouseX.start) / input.mouseX.range;
        // mouse y input
        input.mouseY.current = mouse.y;
        input.mouseY.fraction = (input.mouseY.current - input.mouseY.start) / input.mouseY.range;
        // scroll y input
        input.scrollY.current = container?.scrollTop;
        input.scrollY.fraction = (input.scrollY.current - input.scrollY.start) / input.scrollY.range;
    }

    function updateOutputs(){
        //output.x.opposite = output.x.end - (input.mouseX.fraction * output.x.range)
    
        //output.y.opposite = output.y.end - (input.mouseY.fraction * output.y.range)

        output.y.current = output.y.start + (input.scrollY.fraction * output.y.range)
    }

    function updateEachParallaxItem(){
        itemsArray.forEach(function(item, i){
            var depth = parseFloat(item.dataset.depth, 10);
            var itemInput = {
                scrollY: {
                    start: item.offsetParent.offsetTop,
                    startspec: item.offsetParent.offsetTop - 20,
                    end: item.offsetParent.offsetTop + container.innerHeight,
                }
            }
            itemInput.scrollY.range = itemInput.scrollY.end - itemInput.scrollY.start;
            itemInput.scrollY.rangespec = itemInput.scrollY.end - itemInput.scrollY.startspec;
            itemInput.scrollY.fraction = (input.scrollY.current - itemInput.scrollY.start) / input.scrollY.range;
            itemInput.scrollY.fractionspec = (input.scrollY.current - itemInput.scrollY.startspec) / input.scrollY.range;
            var itemOutputYCurrent =  output.y.start + (itemInput.scrollY.fraction * output.y.range)
            var itemOutputYCurrentspec =  output.y.start + (itemInput.scrollY.fractionspec * output.y.range)
            var itemOutput = {
                x: output.x.current - (output.x.current * depth),
                y: itemOutputYCurrent * depth,
                yspec: itemOutputYCurrentspec * depth,
                zIndex: output.z.range - (output.z.range * depth),
                scale: output.scale.start + (output.scale.range * depth),
                blur: (depth - output.blur.startingDepth) * output.blur.range
            };
            item.style.zIndex = itemOutput.zIndex;
                if (itemOutput.y > 170){
                    itemOutput.y = 170
                }
                item.style.transform = `scale(0.8) translateX(${itemOutput.y}px)`;
                if (i === 8 || i === 9 || i === 10 || i === 11){
                    if (itemOutput.y > 85){
                        itemOutput.y = 170
                    }
                    item.style.transform = `scale(0.8) translateX(${itemOutput.y}px)`;
                }
        })

    }

    function handleMouseMove(e){
        mouse.x = e.clientX;
        mouse.y = e.clientY;

        updateInputs();
        updateOutputs();
        updateEachParallaxItem();
    }

    function handleScroll(){
        updateInputs();
        updateOutputs();
        updateEachParallaxItem();
        updateArrow();
    }

    function handleResize(){
        input.mouseX.end = window.innerWidth;
        input.mouseX.range = input.mouseX.end - input.mouseX.start;

        input.mouseY.end = window.innerHeight;
        input.mouseY.range = input.mouseY.end - input.mouseY.start;
        
        input.scrollY.end = container?.scrollHeight - container?.clientHeight;
        input.scrollY.range = input.scrollY.end - input.scrollY.start
    }


    // window.addEventListener('mousemove', handleMouseMove)
    if (container) {
        container.addEventListener('scroll', handleScroll);
        container.addEventListener('scroll', function(e) {
            let buttons = document.getElementsByClassName('buttons');
            let buttonsArray = Array.from(buttons);

            for (let i = 0; i < buttonsArray.length; i++) {
                let elementHeight = imagesArray[0].height
                let scrollTop = e.target.scrollTop - divsArray[0].scrollHeight
                let scrollTop2 = e.target.scrollTop - divsArray[1].scrollHeight * 2.5
                let scrollTop3 = e.target.scrollTop - divsArray[2].scrollHeight * 2.5
                let opacity = ((1 - (elementHeight - scrollTop) / elementHeight) * 0.9) + 1.3;
                let opacity2 = ((1 - (elementHeight - scrollTop2) / elementHeight) * 0.9) + 2.5;
                let opacity3 = ((1 - (elementHeight - scrollTop3) / elementHeight) * 0.9) + 1.6;

                for (let i=0; i <= imagesArray.length; i++){
                    imagesArray[0].style.opacity = `${opacity}`
                    imagesArray[1].style.opacity = `${opacity2}`
                    imagesArray[2].style.opacity = `${opacity3}`
                }
            }
      })
    }

    window.addEventListener('resize', handleResize)

   
    updateInputs();
    updateOutputs();
    updateEachParallaxItem();

    useEffect(() => {
        setTimeout(() => {
          return setLetterClass('text-animate-hover')
        }, 4000)
      }, [])

      useEffect(() => {
        
        const timer = setTimeout(() => {
            setWillVisible(true)
        }, 6000); 
        const timer2 = setTimeout(() => {
            setIsVisible(true);
        }, 5500); 
        
        return () => clearTimeout(timer, timer2);
      }, []);

    return (
        <>
        <div class="scroll-prompt" id="js_scrollPrompt"><AiOutlineDown className={`${isVisible ? 'slidedown' : 'scroll-prompt-shape'}`}></AiOutlineDown></div>
        <div id='container' className='container home-page' style={{overflowY: `${willVisible ? 'scroll' : 'hidden'}`, zIndex: `${willVisible ? '0' : '4'}`}}>
            <div className="text-zone">
                <h1>
                <span className={letterClass}>H</span>
                <span className={`l${letterClass} _12`}>I</span>
                <br/> 
                <span className={`l${letterClass} _13`}>I</span>
                <span className={`l${letterClass} _14`}>'m</span>
                <img src={LogoTitle} alt="developer" />
                <AnimatedLetters letterClass={letterClass}
                strArray={nameArray}
                idx={15} />
                <br/>
                <AnimatedLetters letterClass={letterClass}
                strArray={jobArray}
                idx={22} />
                </h1>
                <h2 className='desc-text'>Fullstack Developer / JavaScript Expert / Adventurer</h2>
                <Link to="/contact" className={`${willVisible ? 'flat-button' : 'no-button'}`}>CONTACT ME</Link>
            </div>
            <Logo />
        <div className='my-text'>
            <div id='hello' style={{visibility: `${willVisible ? 'visible' : 'hidden'}`}}>
                <text data-depth='0.1' id='text-head' className='parallax-item firsthead'>Ultima</text>
                <br/>
                <text data-depth='0.1' id='text-sub-head' className='parallax-item'>Full Stack Developer - UI Designer</text>
                <br/>
                <text data-depth='0.1' id='text-sub' className='parallax-item'>Ultima is a cutting-edge website that offers a luxurious and exclusive car rental experience for discerning customers who demand the best in automotive excellence.</text>
                <div data-depth='0.1' id='button-container' className='parallax-item'>
                        <a target='_blank' href='https://github.com/sdbarlow/UltimaClient'><button className='buttons'>See Code</button></a>
                        <a id='secondbtn' target='_blank' href='https://ultima-client.vercel.app/'><button>Demo</button></a>
                    </div>
            </div>
            <div className='image-container'>
                    <img src={Ultima} className='images' alt='ultima'/>
            </div>
        </div>
        <div className='my-text'>
            <div id='hello' >
                    <text data-depth='0.1' id='text-head' className='parallax-item secondhead'>TriviaBall</text>
                    <br/>
                    <text data-depth='0.1' id='text-sub-head' className='parallax-item'>Full Stack Developer - UI Designer</text>
                    <br/>
                    <text data-depth='0.1' id='text-sub' className='parallax-item'>TriviaBall is an interactive web game built with React, featuring a nostalgic 8-bit theme. It challenges players' knowledge across popular subjects.</text>
                    <div data-depth='0.1' id='button-container' className='parallax-item'>
                        <a target='_blank' href='https://github.com/sdbarlow/TriviaBall2'><button className='buttons'>See Code</button></a>
                        <a id='secondbtn' target='_blank' href='https://triviaball-buf3.onrender.com/'><button>Demo</button></a>
                    </div>
            </div>
            <div className='image-container'>
                        <img src={TriviaBall} className='images' alt='triviaball'/>
            </div>
            </div>
        <div className='my-text' id='last'>
            <div id='hello' className='last'>
                    <text data-depth='0.1' id='text-head' className='parallax-item thirdhead'>NetHive</text>
                    <br/>
                    <text data-depth='0.1' id='text-sub-head' className='parallax-item'>Front End Developer - UI Designer</text>
                    <br/>
                    <text data-depth='0.1' id='text-sub' className='parallax-item'>Nethive is a collaborative web project inspired by Slack, offering a user-friendly platform for seamless team and community communication.</text>
                    <div data-depth='0.1' id='button-container' className='parallax-item last'>
                        <a target='_blank' href='https://github.com/agalev/phase-4-project-NetHive'><button className='buttons'>See Code</button></a>
                    </div>
                </div>
            <div className='image-container'>
                        <img src={NetHive} className='images' alt='nethive'/>
            </div>
        </div>
        </div>
        <Loader type='pacman'/>
        </>
    )
}

export default Home